"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
function Header(props) {
    var _a;
    var isCoupon = props.isCoupon, isLink = props.isLink, title = props.title, subTitle = props.subTitle, link = props.link;
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    function renderSubTitle() {
        if (!subTitle) {
            return null;
        }
        if (isLink && link) {
            return (react_1.default.createElement("a", { href: link, target: "_blank", className: "header-sub-link", rel: "noreferrer" },
                subTitle,
                " >"));
        }
        return react_1.default.createElement("h2", { className: "header-sub-title" }, subTitle);
    }
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(classPrefix, "-card-header"), (_a = {},
            _a['is-coupon-card'] = isCoupon,
            _a)) },
        react_1.default.createElement("h1", { className: "header-title" }, title),
        renderSubTitle()));
}
exports.default = Header;
//# sourceMappingURL=Header.js.map